import React, { useState } from "react";

const Page15 = () => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div style={{paddingTop: '100px'}}>
      <div
        className="col-md-12 fontS-18"
        style={{ marginBottom: 40, paddingBottom: 5 }}
      >
        <p>
          Precisa relembrar? Sempre que for necessário, consulte a versão mais recente das bases legais e corporativas nos canais oficiais: 
        </p>
      </div>


      {/* Caixa de destaque */}
      <div
        style={{
          backgroundColor: "#e9ffcd",
          borderLeft: "6px solid #89D127",
          padding: "25px",
          borderRadius: "6px",
          color: "#0f8504",
          fontSize: "18px",
          lineHeight: "1.6",
          marginBottom: 40,
        }}
      >
        <ul>
          <li>Norma CEPRAM nº 4578</li>
          <li>HSE GQH-GQHSE-PUB-9-283785 – Management of Change in Production</li>
          <li>PASS-ESG-000103 – Safe Design and Operation of Processes and Plants</li>
          <li>PASS-ESG-000001 – Health, Safety, Environment (HSE) Management and HSE Key Requirements</li>
        </ul>
      </div>

      <div className="col-md-12 fontS-18" style={{ marginBottom: 40, paddingBottom: 5 }}
      >
        <p>
          Esses documentos apoiam a aplicação prática dos conceitos e ajudam a garantir alinhamento com os requisitos estabelecidos. 
        </p>

      </div>
    </div>
  );
};

export default Page15;